export const $_hole = {
	scoreClasses(hole) {
		if (!hole.score) return {};
		return {
			'bg-yellow-200': !!hole.score_albatross,
			'bg-yellow-600': !!hole.score_eagle,
			'bg-red-600 text-white': !!hole.score_birdie,
			'bg-blue-600 text-white': !!hole.score_bogey,
			'bg-gray-500 text-white': !!hole.score_double_bogey,
			'bg-gray-900 text-white': !!hole.score_triple_or_worse,
		};
	},
}

export {$_hole as default};
